export * from './risk-index.component';
export * from './risk-scoring.component';